import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronExpandY = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polyline", { points: "13 7 10 4 7 7", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
        React.createElement("polyline", { points: "13 13 10 16 7 13", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" })));
};
//# sourceMappingURL=IconChevronExpandY.js.map